import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { environment } from "environments/environment";
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';

@Injectable()
export class CatAnalyticsService { 
    catAnalyaticsUrl = 'CATAnalytics/data';
    groupNamesUrl = 'CATAnalytics/groups';
    fieldNamesUrl = 'CATAnalytics/fields';
    getDateUrl = 'CATAnalytics/dates';
    isOpenCommentViewer: boolean = false;
    isDisplayDateRangeFilter: boolean = false;
    isDisplayAddCommentForm: boolean = false;

    constructor(private http: HttpClient,
        private sharedHttpClientService: SharedHttpClientService,
        private urlsService: UrlsService,
        private userService: UserService) {

    }

    getCatAnalyticsData(data:any) {
        return this.sharedHttpClientService.post(environment.apiUrl +"API/"+this.userService.getActiveMPID()+"/"+ this.catAnalyaticsUrl, data);
    }

    getGroups(data:any) {
        return this.sharedHttpClientService.post(environment.apiUrl +"API/"+this.userService.getActiveMPID()+"/"+ this.groupNamesUrl, data);
    }

    getFieldNames(data:any) {
        return this.sharedHttpClientService.post(environment.apiUrl +"API/"+this.userService.getActiveMPID()+"/"+ this.fieldNamesUrl, data);
    }

    getCatAnalyticsRecentDate(data:any) {
        return this.sharedHttpClientService.post(environment.apiUrl +"API/"+this.userService.getActiveMPID()+"/"+ this.getDateUrl, data);
    }

    getAllCatAnalyticsCommentCount(data:any) {
        return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.CAT_Anlytics_All_COMMENT_COUNT),  data);
    }
}